<template>
    <div>
        <img
            v-if="previewImage"
            :src="previewImage"
            class="preview d-block mb-3"
            ref="previewImageRef"
        />

        <input
            :name="`${name}[file]`"
            :required="required"
            type="file"
            accept="image/jpeg, *.jpeg, *.jpg, image/png, *.png"
            @change.prevent="updateFiles($event.target.files)"
            @click="abortCropping"
            ref="inputFileRef"
        />

        <template v-if="cropping">
          <input type="hidden" :name="`${name}[cropping][x]`" :value="cropping.x">
          <input type="hidden" :name="`${name}[cropping][y]`" :value="cropping.y">
          <input type="hidden" :name="`${name}[cropping][width]`" :value="cropping.width">
          <input type="hidden" :name="`${name}[cropping][height]`" :value="cropping.height">
        </template>

        <cropper
            class="mt-3"
            v-if="croppableImageBase64String"
            :imageBase64String="croppableImageBase64String"
            :aspect-ratio="aspectRatio"
            @updateCropping="updateCropping($event)"
            @finishCropping="finishCropping($event)"
            @abortCropping="abortCropping"
        ></cropper>
    </div>
</template>

<style lang="scss" scoped>
  img.preview {
    max-width: 240px;
    width: 100%;
    height: auto;
  }
</style>

<script setup lang="ts">
import { ref, toRefs } from "vue";
import Cropper from './_cropper.vue';
const fileToBase64 = file => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = () => {
    reader.onload = null;
    reader.onerror = null;
    resolve(reader.result);
  };
  reader.onerror = error => {
    reader.onload = null;
    reader.onerror = null;
    reject(error);
  };
});
const props = defineProps({
  name: String,
  currentImage: String,
  required: Boolean,
  aspectRatio: {
    type: Number,
    default: NaN
  }
});
const {
  name,
  currentImage,
  required,
  aspectRatio
} = toRefs(props);
const previewImageRef = ref(null);
const inputFileRef = ref(null);
const $refs = {
  get previewImage() {
    return previewImageRef.value;
  },
  get inputFile() {
    return inputFileRef.value;
  }
};
const previewImage = ref(currentImage.value ? currentImage.value : '');
const croppableImageBase64String = ref(null);
const cropping = ref(null);
async function updateFiles(files) {
  if (files.length > 0) {
    croppableImageBase64String.value = await fileToBase64(files[0]);
    previewImage.value = null;
  }
}
function updateCropping(cropdata) {
  cropping.value = {
    x: cropdata.x,
    y: cropdata.y,
    width: cropdata.width,
    height: cropdata.height
  };
}
function finishCropping(base64Image) {
  previewImage.value = base64Image;
  croppableImageBase64String.value = null;
  if ($refs.previewImage) {
    if (window.pageYOffset > $refs.previewImage.offsetTop - 20) {
      window.scrollTo({
        top: $refs.previewImage.offsetTop - 20,
        behavior: 'smooth'
      });
    }
  }
}
function abortCropping() {
  $refs.inputFile.value = null;
  cropping.value = null;
  croppableImageBase64String.value = '';
  if (currentImage.value) {
    previewImage.value = currentImage.value;
  }
}
</script>
